import { Stack } from '@adc/parallax-component-library';

type FormContainerProps = {
  hasHiddenUserInput?: boolean;
  hasBigGaps?: boolean;
};

// more informations: https://www.chromium.org/developers/design-documents/create-amazing-password-forms/
const FormContainer = ({
  children,
  hasBigGaps = false,
  hasHiddenUserInput = false,
}: React.PropsWithChildren<FormContainerProps>) => {
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
      }}
    >
      <Stack display="flex" flexDirection="column" gap={hasBigGaps ? '$6' : '$4'}>
        {children}
      </Stack>
      {/* NOTE: Fix to make chrome not complain about missing accessibility features in the form */}
      {hasHiddenUserInput ? (
        <input hidden id="userName" name="username" autoComplete="username" defaultValue="" />
      ) : null}
    </form>
  );
};

FormContainer.displayName = 'FormContainer';

export { FormContainer };
